import { render, staticRenderFns } from "./ym.vue?vue&type=template&id=557372fc&scoped=true&"
import script from "./ym.vue?vue&type=script&lang=js&"
export * from "./ym.vue?vue&type=script&lang=js&"
import style0 from "./ym.vue?vue&type=style&index=0&id=557372fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557372fc",
  null
  
)

export default component.exports